<!-- (click)="selectCarrier()" -->
<div class="voluntaryCard">
    <div class="box cardHeader" [ngClass]="{'selected': isPlanSelected}">
        <mat-radio-group>
            <mat-radio-button [checked]="isPlanSelected" (change)="carrierNameOnChange($event)" [value]="voluntaryCarrier.code" class="">
                <ng-container *ngIf="isPlanSelected">Selected</ng-container>
                <ng-container *ngIf="!isPlanSelected">Not Selected</ng-container>
            </mat-radio-button>
        </mat-radio-group>
    </div>
    <div class="box cardLogo">
        <img mat-card-image *ngIf="voluntaryCarrier.selectedCarrierLogoUrl" class="logo" src="{{voluntaryCarrier.selectedCarrierLogoUrl}}" />
    </div>
    <div class="box cardName">{{voluntaryCarrier.name}}</div>
</div>
